<template>
    <div>
        <div v-if="!$store.state.isMobile" class="wscn-http404-container">
            <div class="wscn-http404">
                <h3 class="title">{{ langPage['v4-404']['TXT_whoops'] }}</h3>
                <p class="title">{{ langPage['v4-404']['TXT_rienavoirici'] }}</p>
                <p class="content">{{langPage['404']['TXT_pageinexistant']}}</p>
                <div class="btnDiv">
                    <el-button class="btnLeft" @click="$router.push('/')">{{langPage['404']['TXT_retouracceuil']}}</el-button>
                    <el-button class="btnRight" @click="$router.go(-1)">{{langPage['404']['TXT_pageprecedent']}}</el-button>
                </div>
            </div>
        </div>
        <div v-if="$store.state.isMobile" class="mwscn-http404-container">
            <div class="wscn-http404" align="center">
                <img class="imgNotOk" src="@/assets/img/NotOk.svg"/>
                <h3 class="title">{{ langPage['v4-404']['TXT_whoops'] }}</h3>
                <p class="title">{{ langPage['v4-404']['TXT_rienavoirici'] }}</p>
                <p class="content">{{langPage['404']['TXT_pageinexistant']}}</p>
                <div>
                    <el-button class="btnLeft" @click="$router.push('/')">{{langPage['404']['TXT_retouracceuil']}}</el-button>
                </div>
                <div>
                    <el-button class="btnRight" @click="$router.go(-1)">{{langPage['404']['TXT_pageprecedent']}}</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'Page404',
        computed: {
            message() {
                return 'The webmaster said that you can not enter this page...'
            },
          langPage() {
            return this.$store.state['langPage']
          }
        }
    }
</script>

<style lang="less" scoped src="@/assets/viewCss/views/404.less">
</style>
